import { render, staticRenderFns } from "./SportelloRicercaStanzeView.vue?vue&type=template&id=fcd40b8e&"
import script from "./SportelloRicercaStanzeView.vue?vue&type=script&lang=ts&"
export * from "./SportelloRicercaStanzeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports